import { message, Row, Col, Select } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  InputItem,
  ButtonItem,
  ErrorItem,
  SelectItem,
  SwitchItem,
  SelectEmpleadosItem,
} from "../../../../Components/Items";

const { Option } = Select;

class AgregarEtapa extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    etapasOptions: null,
    todasEtapasAnteriores: [],
    todasEtapasSiguientes: [],
  };

  componentDidUpdate(prevProps) {
    // Solo consulta si el modal acaba de abrirse
    if (!prevProps.visible && this.props.visible) {
      this.consultarEtapas();
    }
  }



  consultarEtapas = () => {
    this.setState({ loading: true });

    axios
      .post(
        "etapas/selectTodasEtapas",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          if (res.data.etapas && res.data.etapas.length > 0) {
            const options = res.data.etapas.map((etapa) => (
              <Option key={etapa._id} value={etapa._id}>
                {etapa.nombre}
              </Option>
            ));

            this.setState({
              etapasOptions: options,
              todasEtapasAnteriores: options,
              todasEtapasSiguientes: options,
            });
          }
        } else {
          message.error("Error al cargar las etapas");
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.error("Error al consultar etapas:", error);
        message.error("Error al cargar las etapas");
      });
  };


  cerrarAgregarEtapa(codigo) {
    this.props.cerrarModal(codigo);
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    this.setState({ loading: true });

    axios
      .post(
        "etapas/agregarEtapa",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });

        if (res.data.success === 2) {
          const nuevaEtapa = res.data.etapa;

          if (nuevaEtapa && nuevaEtapa._id) {
            message.success("Etapa agregada correctamente");
            this.formRef.current.resetFields();
            this.cerrarAgregarEtapa(nuevaEtapa._id);
          } else {
            message.error("Ocurrió un error al guardar");
          }
        } else {
          message.error("Error al agregar la etapa");
        }

      })
      .catch((err) => {
        this.setState({ loading: false });
        console.error(err);
        message.error("Error al conectar con el servidor");
      });
  }



  // Taxidermia: la etapa se controla por persona en el Dashboard (tablero "Por persona" y
  // reporte semanal). `personal` son los empleados que la trabajan.
  renderControlPorPersona() {
    return (
      <>
        <FormItem
          name="controlPorPersona"
          label="Controlar trabajo por persona"
          margin
          tooltip="Cada pieza de esta etapa se asigna a una persona (montador, retocador...) desde el Dashboard, con fecha de inicio y de término, y sale en el reporte semanal de producción"
          valuePropName="checked"
        >
          <SwitchItem />
        </FormItem>
        <FormItem shouldUpdate noStyle>
          {({ getFieldValue }) =>
            getFieldValue("controlPorPersona") ? (
              <FormItem
                name="personal"
                label="Personal de la etapa"
                margin
                tooltip="Las personas que salen como columnas en el tablero por persona"
              >
                <SelectEmpleadosItem
                  empresaId={this.props.empresaId}
                  headersToken={this.props.headersToken}
                  sinBorde
                  width="100%"
                  mode="multiple"
                  placeholder="Empleados que trabajan esta etapa"
                />
              </FormItem>
            ) : null
          }
        </FormItem>
      </>
    );
  }

  render() {
    return (
      <ModalItem
        title="Agregar Etapa"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={() => this.cerrarAgregarEtapa()}

        paddingTop
      >
        <Form
          ref={this.formRef}
          name="AgregarEtapa"
          layout
          bottom={
            <ButtonItem
              type="primary"
              htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }}
            >
              Agregar
            </ButtonItem>
          }
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <Row style={{ width: "100%" }}>
            <Col span={24}>
              <FormItem
                name="nombre"
                label="Nombre"
                required
                max={100}
                margin
                pattern
              >
                <InputItem placeholder="Nombre" />
              </FormItem>
              <FormItem
                name="descripcion"
                label="Descripción"
                margin
                pattern
                required
              >
                <InputItem placeholder="Descripción" />
              </FormItem>
              <FormItem
                name="nombreAnterior"
                label="Etapa Anterior"
                margin
              >
                <SelectItem mode="multiple" placeholder="Selecciona la etapa anterior">
                  {this.state.todasEtapasAnteriores}
                </SelectItem>
              </FormItem>
              <FormItem
                name="nombreSiguiente"
                label="Etapa Siguiente"
                margin
              >
                <SelectItem mode="multiple" placeholder="Selecciona la etapa siguiente">
                  {this.state.todasEtapasSiguientes}
                </SelectItem>
              </FormItem>
              <FormItem
                name="editarAlEntrar"
                label="Editar al entrar"
                margin
                tooltip="Si se activa, al entrar a esta etapa se abrirá el formulario de edición"
                valuePropName="checked"
              >
                <SwitchItem />
              </FormItem>
              <FormItem shouldUpdate noStyle>
                {({ getFieldValue }) => {
                  const editarAlEntrar = getFieldValue("editarAlEntrar");

                  if (!editarAlEntrar) return null;

                  // Lista de campos para evitar repetición
                  const campos = [
                    { nombre: "Observaciones", label: "Editar observaciones" },
                  ];

                  if (this.props.taxidermia) {
                    campos.push(
                      { nombre: "Empleados", label: "Editar empleados" },
                      { nombre: "FormaVentaId", label: "Editar Venta" },
                      { nombre: "FechaEntrega", label: "Editar Fecha de entrega" },
                      { nombre: "Posicion", label: "Editar posición" },
                      { nombre: "Talla", label: "Editar talla" },
                    );
                  }

                  return (
                    <Row gutter={16}>
                      {campos.map((campo) => {
                        const editarKey = `editar${campo.nombre}`;
                        const requeridoKey = `editar${campo.nombre}Requerido`;
                        const isEditable = getFieldValue(editarKey);

                        return (
                          <Col span={24} key={campo.nombre}>
                            <Row align="middle" gutter={12}>
                              <Col span={12}>
                                <FormItem
                                  name={editarKey}
                                  label={campo.label}
                                  margin
                                  labelCol={{ span: 16 }}
                                  wrapperCol={{ span: 8 }}
                                  valuePropName="checked"
                                >
                                  <SwitchItem />
                                </FormItem>
                              </Col>
                              <Col span={12}>
                                {isEditable && (
                                  <FormItem
                                    name={requeridoKey}
                                    label="¿Requerido?"
                                    valuePropName="checked"
                                    margin
                                  >
                                    <SwitchItem />
                                  </FormItem>
                                )}
                              </Col>
                            </Row>
                          </Col>
                        );
                      })}
                    </Row>
                  );
                }}
              </FormItem>
              {this.props.taxidermia && this.renderControlPorPersona()}
            </Col>

          </Row>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    taxidermia: state.empresa.taxidermia,
  };
};

export default connect(mapStateToProps)(AgregarEtapa);
